import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseItemSaturationOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-saturation-option';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgSaturationOption(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const updateSaturation = (saturation: number, undoable = true): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          videoBackgroundItemObject: {
            effects: {
              saturation,
            },
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemSaturationOption saturation={currentPageBackground.details.videoBackgroundItemObject.effects.saturation} updateSaturation={updateSaturation} />;
}
